import { useMutation } from "@tanstack/react-query";
import axiosInstance from "@/lib/axios";
import { toast } from "sonner";
import {
  createLeadQualificationEndpoint,
  qualificationEdpoints,
} from "@/config/endpoints";

export function useQualificationMutation() {
  const createLeadQualification = useMutation({
    mutationFn: async (data: any) => {
      return axiosInstance.post(createLeadQualificationEndpoint, data);
    },
    onSuccess: () => {
      toast.success("Successfully Added Qualification");
    },
    onError: (error: any) => {
      console.error(error);
      const msg = error.response?.data?.message || "Failed to create lead";
      toast.error(msg);
    },
  });

  const updateQualificationScore = useMutation({
    mutationFn: async ({ id, data }: { id: number; data: any }) => {
      return axiosInstance.patch(`${qualificationEdpoints}/score/${id}`, data);
    },
    onSuccess: () => {
      toast.success("Qualification updated successfully");
    },
    onError: (error: any) => {
      console.error(error);
      const msg =
        error.response?.data?.message || "Failed to update qualification";
      toast.error(msg);
    },
  });

  return { createLeadQualification, updateQualificationScore };
}
